<div class="newLogin">
	<div class="container-fluid">
		<div *ngIf="login.changePassVar == 0" class="row">
			
			<div class="col-md-6 col-12 leftLog order-1 order-md-0">
				<div class="logo" *ngIf="sesion.view != 'pntd' && sesion.view != 'bc'">
					<a href="https://www.midatacredito.com">
						<img src="assets/images/change/logo_midc_w.svg" title="Midatacredito" alt="Midatacredito">
					</a>
				</div>
				<div class="logo" *ngIf="sesion.view == 'bc'">
					<!-- <a href="https://www.midatacredito.com"> -->
						<img src="assets/images/change/logo_bc_blanco_202308.svg" title="Buscacredito" alt="Buscacredito">
					<!-- </a> -->
				</div>
				<div class="logo" *ngIf="sesion.view == 'pntd'">
					<!-- <a href="https://www.midatacredito.com"> -->
						<img src="assets/images/change/logo_pad_blanco_202308.svg" title="Ponte al día" alt="Ponte al día">
					<!-- </a> -->
				</div>
				<div class="titlePpal" *ngIf="sesion.view != 'pntd' && sesion.view != 'bc'">Bienvenido a Midatacrédito</div>
				<div class="titlePpal" *ngIf="sesion.view == 'bc'">Bienvenido a Buscacrédito</div>
				<div class="titlePpal pntd" *ngIf="sesion.view == 'pntd'">Bienvenido a Ponte al Día</div>
				<div class="descriptionPpal" *ngIf="sesion.view != 'pntd' && sesion.view != 'bc'">Aprovecha todos los beneficios de tener monitoreada y protegida tu información personal y crediticia.</div>
				
				<!-- Ingreso de datos para identificar flujo que debe seguir el usuario. -->
				<div *ngIf="login.paso1 == 1" id="paso1" class="contentForms">
					<div  class="title">Ingresa tus datos</div>
					<div  class="subtitle">Por favor ingresa tu identificación, así podemos saber si debes ingresar o registrarte.</div>
					<form  (keydown.enter)="$event.preventDefault()" (ngSubmit)="login.procesoPaso1(datosPaso1)" #datosPaso1="ngForm" autocomplete="off">
						<mat-form-field class="w-100">
							<mat-label>Tipo de documento</mat-label>
							<mat-select id="tipoDocumento" name="tipoDocumento" class="form-control" [(ngModel)]="login.modelPaso1.tipoDocumento" pattern="[1-9]" #tipoDocumento="ngModel" required="required">
								<mat-option [value]="1 | number ">Cédula de ciudadanía</mat-option>
								<mat-option [value]="4 | number ">Cédula de extranjería</mat-option>
								<!-- <mat-option [value]="9 | number ">Permiso especial de permanencia</mat-option> -->
							</mat-select>
						</mat-form-field>
						<mat-form-field class="w-100">
							<input matInput placeholder="No. de documento" type="text"
								class="form-control" id="documento" [(ngModel)]="login.modelPaso1.documento"
								pattern="^[1-9]\d{0,10}$" #documento="ngModel" required="required" maxlength="11"
								name="documento" [ngClass]="{'is-valid': documento.valid, 'is-invalid': ( (documento.errors?.['required'] || documento.errors?.['pattern']) && documento.touched ) }">
							<mat-error *ngIf="documento?.errors?.['required']" class="invalid-feedback">Campo obligatorio.</mat-error>
							<mat-error *ngIf="documento?.errors?.['pattern']" class="invalid-feedback">Documento no válido. Ingresar solo números.</mat-error>
						</mat-form-field>
						<button *ngIf="login.loaderPaso1 == 0" id="userExist" [attr.disabled]="datosPaso1.valid ? null : 'disabled'" [ngClass]="{'disabled': !datosPaso1.valid }" type="submit">Continuar</button>
						<div *ngIf="login.loaderPaso1 == 1" class="spinGral">
							<div class="spinner-border spinPurple" role="status">
								<span class="sr-only">Loading...</span>
							</div>
							<div class="textSpin">Por favor espera un momento, estamos verificando tu existencia en nuestro sistema.</div>
						</div>
						<div *ngIf="login.errorPaso1" class="errorService">{{login.errorMsgService.errorMessage[0]}} <br> <span>[{{login.errorMsgService.errorMessage[1]}}]</span></div>
						<!-- <div *ngIf="login.errorPaso1 == 1" class="errorService">En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde.</div>
						<div *ngIf="login.errorToken == 1" class="errorService">Se ha presentado un error. Por favor intentalo de nuevo.</div>
						<div class="errorService">En estos momentos tenemos algunas demoras en los tiempos de respuesta de la plataforma.</div> -->
					</form>
					<!-- <div *ngIf="sesion.product == 'vrf'" class="maintenance">
						<div class="img-main">
							<img src="assets/images/Intermitencia.svg" />
						</div>
						<div class="txt-main">
							<h4>¡Lamentamos las molestias!</h4>
							<p>En este momento, estamos trabajando en el mantenimiento de nuestros servicios.</p>
							<p>Volveremos a estar disponibles próximamente.</p>
						</div>
					</div> -->
				</div>				

				<!-- Pantalla para ingresar la contraseña y continuar con el inicio de sesión... -->
				<div *ngIf="login.paso2 == 1" id="paso2" class="contentForms">
					<div class="title">¡Hola!</div>
					<div class="subtitle">
						Bienvenido a Midatacrédito, es momento de tomar el control de tu vida financiera.<br /><br />
						<span>Ingresa tu contraseña para continuar.</span>
					</div>
					<form (keydown.enter)="$event.preventDefault()" (ngSubmit)="login.procesoPaso2(datosPaso2.valid)" #datosPaso2="ngForm" autocomplete="off">
						<mat-form-field class="w-100">
							<input matInput [type]="hideContra ? 'password' : 'text'" id="contra"
								class="form-control" [(ngModel)]="login.modelPaso2.password" #contra="ngModel"
								required="required" placeholder="Contraseña" name="contra">
								<div mat-icon-button matSuffix (click)="hideContra = !hideContra" style="cursor: pointer;">
									<i class="fa" [ngClass]="{'fa-eye-slash' : hideContra, 'fa-eye' : !hideContra}"></i>
								</div>
						</mat-form-field>
						<div class="remember">
							<a id="olvContrasena" (click)="recordar_contrasena(content.info.login.urlremember)">- {{ content.info.login.textoremember }} -</a>
						</div>
						<button *ngIf="login.loaderPaso2 == 0" id="ingClave" [attr.disabled]="datosPaso2.valid ? null : 'disabled'" [ngClass]="{'disabled': !datosPaso2.valid }" type="submit">Ingresar</button>
						<div *ngIf="login.loaderPaso2 == 1" class="spinGral">
							<div class="spinner-border spinPurple" role="status">
								<span class="sr-only">Loading...</span>
							</div>
							<div class="textSpin">Por favor espera un momento, estamos validando tus datos de acceso.</div>
						</div>
						<div *ngIf="login.errorPaso2 == 1" class="errorService">Tus datos de inicio de sesión no son correctos. Por favor valídalos para continuar. <span>[{{login.errorMsgService.errorMessage[1]}}]</span></div>
						<div *ngIf="login.errorBlocked == 1" class="errorService">Tu usuario se encuentra bloqueado por exceder el número de intentos erroneos. Por favor inténtalo nuevamente en 30 minutos. <span>[{{login.errorMsgService.errorMessage[1]}}]</span></div>
						<div *ngIf="login.errorOTPCode == 1" class="errorService">Se ha presentado un error en tu solicitud. Por favor inténtalo nuevamente. <span>[{{login.errorMsgService.errorMessage[1]}}]</span></div>
						<div *ngIf="login.errorPaso2Gral == 1" class="errorService">En este momento nuestro sistema no puede responder a tu solicitud, por favor inténtalo más tarde. <span>[{{login.errorMsgService.errorMessage[1]}}]</span></div>
					</form>
				</div>
			</div>
			<app-right-shot class="col-md-6 col-12 order-0 order-md-1 rightShot" [ngClass]="{'bg-bc': sesion.view === 'bc', 'bg-pntd': sesion.view === 'pntd'}" [product]="sesion.view"></app-right-shot>
		</div>

		<!-- Cambiar contraseña para registrar en IAM. -->
		<div *ngIf="login.changePassVar == 1" class="row">
			<div class="col-md-7 col-12 leftLogRec order-1 order-md-0">
				<div class="logo" *ngIf="sesion.view != 'pntd' && sesion.view != 'bc'">
					<a href="https://www.midatacredito.com">
						<img src="assets/images/change/logo_midc.svg" title="Midatacredito" alt="Midatacredito">
					</a>
				</div>
				<div class="logo" *ngIf="sesion.view == 'bc'">
					<!-- <a href="https://www.midatacredito.com"> -->
						<img src="assets/images/change/logo_bc_color_202308.svg" title="Buscacredito" alt="Buscacredito">
					<!-- </a> -->
				</div>
				<div class="logo" *ngIf="sesion.view == 'pntd'">
					<!-- <a href="https://www.midatacredito.com"> -->
						<img src="assets/images/change/logo_pad_color_202308.svg" title="Ponte al día" alt="Ponte al día">
					<!-- </a> -->
				</div>

				<!-- Crear nueva contraseña para registrar en IAM. -->
				<div *ngIf="login.creaPass == 1" id="creaPass" class="contentForms">
					<div class="superior">
						<div class="titNew">Crea tu nueva contraseña</div>
						<div class="desNew">Una contraseña segura debe incluir al menos 8 caracteres, una mayúscula, una minúscula, un número y un carácter especial.</div>
					</div>
					<form autocomplete="off" (ngSubmit)="login.cambiarContrasenaIAM(datos)" #datos="ngForm" autocomplete="off">
						<div class="subtitleRec">Tu contraseña debe tener:</div>
						<div class="requiredItem">
							<i class="fa" [ngClass]="{'fa-times-circle-o' : !caracteres, 'fa-check-circle-o' : caracteres}"></i> Mínimo 8 caracteres y máximo 15.
						</div>
						<div class="requiredItem">
							<i class="fa" [ngClass]="{'fa-times-circle-o' : !upperLower, 'fa-check-circle-o' : upperLower}"></i> Combinación entre MAYÚSCULAS Y minúsculas.
						</div>
						<div class="requiredItem">
							<i class="fa" [ngClass]="{'fa-times-circle-o' : !unNumero, 'fa-check-circle-o' : unNumero}"></i> Al menos un número.
						</div>
						<div class="requiredItem lastItem">
							<i class="fa" [ngClass]="{'fa-times-circle-o' : !unEspecial, 'fa-check-circle-o' : unEspecial}"></i> Al menos un carácter especial.
						</div>
						<div class="row formContra">
							<div class="col-12 col-md-6">
								<mat-form-field class="w-100">
									<input matInput [type]="hideContra ? 'password' : 'text'" placeholder="Nueva contraseña" (input)="validar($any($event.target).value)"
									(blur)="validarConfirm($any($event.target).value)" class="form-control" id="newContra"
									required="required" pattern="^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W\_]).{8,}$" maxlength="15" [(ngModel)]="login.password"
									#newContra="ngModel" name="newContra" [ngClass]="{'is-valid': newContra.valid, 'is-invalid': ( (newContra.errors?.['required'] || newContra.errors?.['pattern']) && newContra.touched ) }">            
									<div mat-icon-button matSuffix (click)="hideContra = !hideContra">
										<i class="fa" [ngClass]="{'fa-eye-slash' : hideContra, 'fa-eye' : !hideContra}"></i>
									</div>
								</mat-form-field>
							</div>
							<div class="col-12 col-md-6">
								<mat-form-field class="w-100">
									<input matInput [type]="hideConfirm ? 'password' : 'text'" placeholder="Confirmar nueva contraseña"
										(blur)="validarConfirm($any($event.target).value)" class="form-control" id="newContraRepeated"
										required="required" pattern="^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W\_]).{8,}$" maxlength="15" name="newContraRepeated"
										[(ngModel)]="login.validatePassword" #newContraRepeated="ngModel">
									<div mat-icon-button matSuffix (click)="hideConfirm = !hideConfirm">
										<i class="fa" [ngClass]="{'fa-eye-slash' : hideConfirm, 'fa-eye' : !hideConfirm}"></i>
									</div>
								</mat-form-field>
							</div>
						</div>
						<div class="row">
							<div class="col-12 col-md-6">
								<button *ngIf="login.loaderChange == 0" [attr.disabled]="datos.valid ? null : 'disabled'" [ngClass]="{'disabled': !datos.valid }" type="submit" class="btnOption">Continuar</button>
								<div *ngIf="login.loaderChange == 1" class="spinGral">
									<div class="spinner-border spinPurple" role="status">
										<span class="sr-only">Loading...</span>
									</div>
									<div class="textSpin">Por favor espera un momento...</div>
								</div>
								<div *ngIf="login.errorRegisterIam" class="errorService">{{login.errorMsgService.errorMessage[0]}} <br> <span>[{{login.errorMsgService.errorMessage[1]}}]</span></div>
								<div *ngIf="login.errorContrasenaDiferente == 1" class="errorService">Por favor confirma correctamente tu contraseña.</div>
								<!-- <div *ngIf="login.errorChangeContraGral == 1" class="errorService">En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde.</div>
								<div *ngIf="login.errorChangeContra == 1" class="errorService">No se ha encontrado una cuenta asociada a los datos de este usuario.</div>
								<div *ngIf="login.errorEnvioCodigo == 1" class="errorService">Error enviando el código de validación al usuario. Por favor vuelve a intentarlo.</div>-->
							</div>
						</div>	
					</form>
				</div>

				<!-- Digita código OTP Brasil para terminar el registro de la contraseña en IAM. -->
				<div *ngIf="login.validaOTPBra == 1" id="validaOTPBra" class="contentForms">

					<!--
						login.paso3 = 0	->	Proceso de validación de código para agregar contraseña al registro de IAM.
						login.paso3 = 1	->	Proceso de validación de código para registrar el equipo del usuario cómo seguro.
						login.paso3 = 2 ->	Proceso de validación de código OTP. 
					-->
					<div *ngIf="login.paso3 == 0" class="superior">
						<div class="titNew">Validación de código</div>
						<div class="desNew">
							Por favor ingresa el código de seis (6) dígitos que enviamos a tu correo electrónico <span>({{ login.emailExist }})</span>.<br /><br />
							Si no lo encuentras en la bandeja de entrada, revisa en la carpeta de spam o no deseados.
						</div>
					</div>
					<div *ngIf="login.paso3 == 1" class="superior">
						<div class="titNew">Registro Equipo Seguro</div>
						<div class="desNew">
							Queremos brindarte una experiencia segura y confiable, por eso te pedimos registrar este equipo como seguro para tus futuros inicios de sesión.<br /><br />
							Por favor ingresa el código de seis (6) dígitos que enviamos a tu correo electrónico <span>({{ login.emailExist }})</span>.<br /><br />
							Si no lo encuentras en la bandeja de entrada, revisa en la carpeta de spam o no deseados.
						</div>
					</div>
					<div *ngIf="login.paso3 == 2" class="superior">
						<div class="titNew">Validación de código</div>
						<div class="desNew">Por favor ingresa el código de seis (6) dígitos que enviamos a tu celular.</div>
					</div>
					<div class="screenCode">
						<div class="subtitle">Ingresa código</div>
						<div class="row">
							<div class="col-12 col-md-12">
								<div class="code">
									<mat-form-field *ngFor="let otp of otpCode; let i=index; trackBy: trackBy">
										<input [(ngModel)]="otpCode[i]" pattern="[1-9]" matInput type="text" maxlength="2" id="codeL{{i}}" (keyup)="next(i)">                                          
									</mat-form-field>
								</div>
								<div class="row">
									<div class="remember col-12 col-md-12">
										<a *ngIf="login.paso3 != 2" id="recCorreo" (click)="login.recCorreo()">¿No reconoces esta cuenta?</a>
										<a *ngIf="login.paso3 == 2" id="recCorreo" (click)="login.recCorreo()">¿No recibiste un código?</a>
									</div>
									<!--<div class="remember col-12 col-md-6">
										<button *ngIf="login.paso3 != 2" id="recCorreo" (click)="login.recCorreo()" class="button-recovery">Cambiar mi correo</button>
										<button *ngIf="login.paso3 == 2" id="recCorreo" (click)="login.recCorreo()" class="button-recovery">Cambiar mi número</button>	
									</div>-->
								</div>
							</div>
						</div>
						<div class="row">
							<div *ngIf="login.paso3 == 0" class="col-12 col-md-6">
								<button *ngIf="login.loaderOTPBra == 0 && (login.codigoOTPBra == undefined || login.codigoOTPBra == '')" disabled type="submit">Validar código</button>
								<button id="recOTP" *ngIf="login.loaderOTPBra == 0 && (login.codigoOTPBra != '' && login.codigoOTPBra != undefined)" (click)="login.verifyOTPBrasil(true)">Validar código</button>
								<div *ngIf="login.loaderOTPBra == 1" class="spinGral">
									<div class="spinner-border spinPurple" role="status">
										<span class="sr-only">Loading...</span>
									</div>
									<div class="textSpin">Por favor espera un momento, estamos verificando tus datos...</div>
								</div>
								<!-- <div *ngIf="login.errorVerifyOTPBrasil == 1" class="errorService">En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde.</div> -->
								<div *ngIf="login.errorCodigo" class="errorService">{{login.errorMsgService.errorMessage[0]}} <br> <span>[{{login.errorMsgService.errorMessage[1]}}]</span></div>
							</div>
							<div *ngIf="login.paso3 == 1" class="col-12 col-md-6">
								<!-- <button *ngIf="login.loaderOTPBra == 0 && (login.codigoOTPBra == undefined || login.codigoOTPBra == '')" disabled type="submit">Validar código</button> -->
								<button id="recOTP" *ngIf="login.loaderOTPBra == 0" [disabled]="login.codigoOTPBra == undefined || login.codigoOTPBra == ''" (click)="login.secondAuthn(true)">Validar código</button>
								<p class="timerOtp" [ngClass]="{'disabled':login.sentOtp}"><b>00:{{login.seconds}}</b> Para poder solicitar un nuevo código</p>
								<button id="btnSendOtp" (click)="login.procesoPaso2(true)" [disabled]="login.seconds < 20" [ngClass]="{'disabled':!login.sentOtp}">- Enviar un nuevo código -</button>
								<div *ngIf="login.loaderOTPBra == 1" class="spinGral">
									<div class="spinner-border spinPurple" role="status">
										<span class="sr-only">Loading...</span>
									</div>
									<div class="textSpin">Por favor espera un momento, estamos verificando tus datos...</div>
								</div>
								<div *ngIf="login.errorVerifyOTPBrasil == 1" class="errorService">En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde.</div>
								<div *ngIf="login.errorVerifyOTPBrasil401 == 1" class="errorService">Error de autenticación, por favor vuelve a intentarlo.</div>
							</div>
							<div *ngIf="login.paso3 == 2" class="col-12 col-md-6">
								<button *ngIf="login.loaderOTPBra == 0 && (login.codigoOTPBra == undefined || login.codigoOTPBra == '')" disabled type="submit">Validar código</button>
								<button id="recOTP" *ngIf="login.loaderOTPBra == 0 && (login.codigoOTPBra != '' && login.codigoOTPBra != undefined)" (click)="login.verifyOTP()">Validar código</button>
								<div *ngIf="login.loaderOTPBra == 1" class="spinGral">
									<div class="spinner-border spinPurple" role="status">
										<span class="sr-only">Loading...</span>
									</div>
									<div class="textSpin">Por favor espera un momento, estamos verificando tu identidad...</div>
								</div>
								<!-- <div *ngIf="login.errorVerifyOTPBrasil401 == 1" class="errorService">Tu código OTP ya expiró. Para recibir otro código, haz click aquí.</div> -->
							</div>
						</div>
					</div>
				</div>

				<!-- Actualizar datos de correo y celular | Inicio. -->
				<div *ngIf="login.actualizaDatos == 1" id="actualizaDatos" class="contentForms">
					<div class="superior">
						<div *ngIf="login.volverActu == 0" class="backSSO" (click)="login.volverCodigo();">
							<img src="assets/images/change/back.svg" alt="cancelar">Cancelar
						</div>
						<div *ngIf="login.volverActu == 1" class="backSSO" (click)="login.volverRecPass();">
							<img src="assets/images/change/back.svg" alt="volver">Volver
						</div>
						<div class="titNew">Actualización de datos</div>
						<!-- <div class="desNew">Para iniciar con el proceso de actualización de datos, es necesario validar tu identidad y prevenir fraudes por suplantación. Necesitamos de tu ayuda respondiendo algunas preguntas.</div> -->
						<div class="desNew">Nos tomamos la seguridad de tu información en serio, por eso es necesario que confirmes esta información:</div>
						<!-- <div class="alertReg">
							<div class="iconAlert">
								<i class="fa fa-exclamation-circle" aria-hidden="true"></i>
							</div>
							<div class="textAlert">Recuerda que esta actualización de datos podrás hacerla sólo una vez por medio de este canal. Para futuros cambios es necesario hacerlo por medio de las líneas de atención.</div>
							<div class="cleanDiv"></div>
						</div> -->
						<mat-form-field class="w-100 calendar" (click)="picker.open()">
							<mat-label>Fecha de expedición de tu documento</mat-label>
							<input matInput [matDatepicker]="picker" (keydown)="false" [(ngModel)]="login.fechaExp" required="required">

							<mat-hint>DD/MM/YYYY</mat-hint>
							<mat-datepicker-toggle class="icon" matIconSuffix [for]="picker"></mat-datepicker-toggle>
							<mat-datepicker #picker></mat-datepicker>
						</mat-form-field>
						<div class="row my-5 pb-0 pb-mb-5">
							<div class="col-12 col-md-6 my-5">
								<button id="iniRecCorreo" *ngIf="login.loaderRecCorreo == 0" (click)="login.iniRecCorreo()" [attr.disabled]="login.fechaExp != undefined ? null : 'disabled'" [ngClass]="{'disabled': login.fechaExp != undefined }">Continuar</button>
								<div *ngIf="login.loaderRecCorreo == 1" class="spinGral">
									<div class="spinner-border spinPurple" role="status">
										<span class="sr-only">Loading...</span>
									</div>
									<div class="textSpin">Por favor espera un momento, estamos validando tus datos...</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- Actualizar datos de correo y celular | Ingreso de datos nuevos. -->
				<div *ngIf="login.ingActualizaDatos == 1" id="ingActualizaDatos" class="contentForms">
					<div class="superior">
						<div class="backSSO" (click)="login.volverCodigo();">
							<img src="assets/images/change/back.svg" alt="volver">Volver
						</div>
						<div class="titNew">Actualización de datos</div>
						<div *ngIf="sesion.tipo != 9" class="desNew">Tu <span>{{ sesion.tipoDoc }}</span> número <span>{{ sesion.numDoc }}</span>, está asociada a la siguiente información, por favor actualiza tus datos para continuar con el cambio.</div>
						<div *ngIf="sesion.tipo == 9" class="desNew">Tu <span>{{ sesion.tipoDoc }}</span> número <span>{{ sesion.numDoc }}</span>, está asociado a la siguiente información, por favor actualiza tus datos para continuar con el cambio.</div>
					</div>
					<form (ngSubmit)="login.actualizacion()" #datosActualizacion="ngForm" autocomplete="off">
						<!-- <div class="subtitle">Información personal</div>
						<div class="row">
							<div class="col-12 col-md-6">
								<mat-form-field class="w-100">
									<input matInput placeholder="Primer nombre" class="form-control"
										type="text" class="form-control" id="nameExist" disabled
										required="required" [(ngModel)]="login.nameExist" #nameExist="ngModel" name="nameExist">
								</mat-form-field>
							</div>
							<div class="col-12 col-md-6">
								<mat-form-field class="w-100">
									<input matInput placeholder="Primer apellido" class="form-control"
										type="text" class="form-control" id="apellidoExist" disabled
										required="required" [(ngModel)]="login.apellidoExist" #apellidoExist="ngModel" name="apellidoExist">
								</mat-form-field>
							</div>
						</div>					 -->
						<div class="subtitle">Información de contacto</div>
						<div class="row">
							<div class="col-12 col-md-6">
								<mat-form-field class="w-100">
									<input matInput placeholder="Correo electrónico" class="form-control"
										type="email" class="form-control" id="email"
										[(ngModel)]="login.emailActu" name="email"
										pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,9}$" #email="ngModel" [ngClass]="{'is-valid': email.valid, 'is-invalid': ( ( email.errors?.['required'] || email.errors?.['pattern'] ) && email.touched ) }">
									<mat-error *ngIf="email?.errors?.['required']" class="invalid-feedback">Campo obligatorio.</mat-error>
									<mat-error *ngIf="email?.errors?.['pattern']" class="invalid-feedback">Correo electrónico inválido.</mat-error>
								</mat-form-field>
							</div>
							<div class="col-12 col-md-6">
								<mat-form-field class="w-100">
									<input matInput class="form-control" placeholder="Número celular"
										type="tel" class="form-control" id="celular" pattern="^(?!.*(\d)\1{4,})(^(3)\d*$)" maxlength="10" minlength="10"
										[(ngModel)]="login.celularActu" #cellPhone="ngModel"
										name="cellPhone" [ngClass]="{'is-valid': cellPhone.valid, 'is-invalid': ( cellPhone.errors?.['required'] && cellPhone.touched ) }">
									<mat-error *ngIf="cellPhone?.errors?.['required']" class="invalid-feedback">Campo obligatorio.</mat-error>
								</mat-form-field>
							</div>
						</div>
						<div class="row">
							<div class="col-12 col-md-6">
								<button *ngIf="login.loaderActu == 0" [attr.disabled]="datosActualizacion.valid ? null : 'disabled'" [ngClass]="{'disabled': !datosActualizacion.valid }" type="submit">Actualizar información</button>
								<div *ngIf="login.loaderActu == 1" class="spinGral">
									<div class="spinner-border spinPurple" role="status">
										<span class="sr-only">Loading...</span>
									</div>
									<div class="textSpin">Por favor espera un momento, estamos procesando tu actualización de datos...</div>
								</div>
								<div *ngIf="login.errorActuGral == 1" class="errorService">En este momento nuestro sistema no puede responder a tu solicitud, por favor intentalo más tarde.</div>
								<div *ngIf="login.errorActuTime == 1" class="errorService">El tiempo para realizar esta actualización ha sido excedido.</div>
							</div>
						</div>
					</form>
				</div>
			</div>
			<div *ngIf="login.actualizaDatos == 1" class="rightLogRec d-none d-md-block col-md-5">
				<div class="principal">
					<img src="assets/images/new_sso/img2.svg" alt="recuperar contraseña">
				</div>
			</div>
		</div>
	</div>
</div>

<!-- Modal - Hora de cambiar contraseña. -->
<div class="modal fade" id="changePass" tabindex="-1" role="dialog" aria-hidden="true">
	<div class="modal-dialog" role="document">
		<div class="modal-content">
			<button type="button" class="close" data-dismiss="modal" aria-label="Close">
				<span aria-hidden="true">&times;</span>
			</button>
			<div class="modal-body">
				<div class="row">
					<div class="col-12 col-md-6">
						<div class="imgModal">
							<img src="assets/images/change/modal_reg.svg" alt="¡Es hora de un cambio de contraseña!" title="¡Es hora de un cambio de contraseña!">	
						</div>
					</div>
					<div class="col-12 col-md-6 modalRight">
						<div class="titModal">¡Es hora de un cambio de contraseña!</div>
						<div class="descriptionModal">Tu seguridad es lo más importante para nosotros, por esta razón te recomendamos hacer un cambio periódico de contraseña, esto para mantener toda tu información segura.</div>
						<div class="botones">
							<button type="button" class="btnModal" data-dismiss="modal" (click)="login.cierraMod();">Cambiar Contraseña</button>
						</div>	
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- Modal - Cambio de contraseña éxitoso. -->
<div class="modal fade" id="contrasenaCambiada" tabindex="-1" role="dialog" aria-hidden="true">
	<div class="modal-dialog" role="document">
		<div class="modal-content">
			<button type="button" class="close" data-dismiss="modal" aria-label="Close">
				<span aria-hidden="true">&times;</span>
			</button>
			<div class="modal-body">
				<div class="row">
					<div class="col-12 col-md-6">
						<div class="imgModal">
							<img src="assets/images/change/modal_reg.svg" alt="¡Hemos cambiado exitosamente tu contraseña!" title="¡Hemos cambiado exitosamente tu contraseña!">	
						</div>
					</div>
					<div class="col-12 col-md-6 modalRight">
						<div class="titModal">¡Hemos cambiado exitosamente tu contraseña!</div>
						<div class="descriptionModal">Puedes seguir disfrutando de todos los beneficios de controlar y mejorar tu vida financiera.</div>
						<div class="botones">
							<button type="button" class="btnModal" data-dismiss="modal" (click)="login.cierraModCambio();">Aceptar</button>
						</div>	
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- Modal - Llamar al Call Center de Experian. -->
<div class="modal fade" id="callExperian" tabindex="-1" role="dialog" aria-hidden="true">
	<div class="modal-dialog" role="document">
		<div class="modal-content">
			<button ype="btutton" class="close" data-dismiss="modal" aria-label="Close">
				<span aria-hidden="true">&times;</span>
			</button>
			<div class="modal-body">
				<div class="row">
					<div class="col-12 col-md-6">
						<div class="imgModal">
							<img src="assets/images/change/modal_reg.svg" alt="Tu usuario está inactivo" title="Tu usuario está inactivo">	
						</div>
					</div>
					<div class="col-12 col-md-6 modalRight">
						<div class="titModal">Tu usuario está inactivo</div>
						<div class="descriptionModal">Para poder acceder a tu cuenta de Midatacredito debes comunicarte con nuestra línea de atención: <span class="link">(601)7430606​ en Bogotá, 01 8000 947 030 Línea Nacional.</span></div>
						<div class="botones">
							<button type="button" class="btnModal" data-dismiss="modal">Aceptar</button>
						</div>	
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- Modal - Error iniciando sesión. -->
<div class="modal fade" id="registroExitoso" tabindex="-1" role="dialog" aria-hidden="true">
	<div class="modal-dialog" role="document">
		<div class="modal-content">
			<button type="button" class="close" data-dismiss="modal" aria-label="Close">
				<span aria-hidden="true">&times;</span>
			</button>
			<div class="modal-body">
				<div class="row">
					<div class="col-12 col-md-6">
						<div class="imgModal">
							<img src="assets/images/change/modal_reg.svg" alt="Error iniciando sesión" title="Error iniciando sesión">	
						</div>
					</div>
					<div class="col-12 col-md-6 modalRight">
						<div class="titModal">Error iniciando sesión</div>
						<div class="descriptionModal">Nuestro sistema no ha podido iniciar tu sesión exitosamente. Por favor ve al inicio e intentalo nuevamente.</div>
						<div class="botones">
							<button type="button" class="btnModal" data-dismiss="modal" (click)="login.irLogin();">Aceptar</button>
						</div>	
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- Modal - Confirmación | Actualización de datos éxitosa. -->
<div class="modal fade" id="confirmacion" tabindex="-1" role="dialog" aria-hidden="true">
	<div class="modal-dialog" role="document">
		<div class="modal-content">
			<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="login.cerrarConfirmacion();">
				<span aria-hidden="true">&times;</span>
			</button>
			<div class="modal-body">
				<div class="row">
					<div class="col-12 col-md-6">
						<div class="imgModal">
							<img src="assets/images/change/modal_reg.svg" alt="¡Hemos actualizado correctamente tus datos!" title="¡Hemos actualizado correctamente tus datos!">	
						</div>
					</div>
					<div class="col-12 col-md-6 modalRight">
						<div class="titModal">¡Hemos actualizado correctamente tus datos!</div>
						<div class="descriptionModal">Disfruta de todos los beneficios de controlar y mejorar tu vida financiera.</div>
						<div class="botones">
							<button type="button" class="btnModal" data-dismiss="modal" (click)="login.goStart();">Aceptar</button>
						</div>	
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- Modal - Error en la actualización de datos. -->
<div class="modal fade" id="errorActualizacion" tabindex="-1" role="dialog" aria-hidden="true">
	<div class="modal-dialog" role="document">
		<div class="modal-content">
			<button type="button" class="close" data-dismiss="modal" aria-label="Close">
				<span aria-hidden="true">&times;</span>
			</button>
			<div class="modal-body">
				<div class="row">
					<div class="col-12 col-md-6">
						<div class="imgModal">
							<img src="assets/images/change/modal_reg.svg" alt="Error actualizando tus datos" title="Error actualizando tus datos">	
						</div>
					</div>
					<div class="col-12 col-md-6 modalRight">
						<div class="titModal">Error actualizando tus datos</div>
						<div class="descriptionModal">
							El correo que ingresaste se encuentra asociado a otra cuenta.<br /><br />
							Para poder acceder a tu cuenta de Midatacredito debes comunicarte con nuestra línea de atención: <span class="link">(601)7430606​ en Bogotá, 01 8000 947 030 Línea Nacional.</span>
						</div>
						<div class="botones">
							<button type="button" class="btnModal" data-dismiss="modal">Aceptar</button>
						</div>	
					</div>
				</div>
			</div>
		</div>
	</div>
</div>